module.exports = __webpack_public_path__ + "media/images/light_grey_3_lines_horizontal-c4422f7f09a2d828ac53c43332b9977e.svg";